import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { DateRange } from "../common/helpers/daterange";
import { Pagination } from "../common/Pagination";
import { useSelector } from 'react-redux';
import Select from "react-select";
import { _Api } from "../api/_call";
import TableLoader from "../../admin/common/TableLoader";
import "../product/product.scss";
import "./userReports.scss";
import { useStickyBlockHeight } from "./useStickyBlockHeight";

const OperationLogReport = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const dropdownRefUser = useRef(null);
  const stickyToolbarRef = useRef(null);
  useStickyBlockHeight(stickyToolbarRef, ".users-report-page", "--users-report-toolbar-height");
  const appliedUsersRef = useRef([]);
  const [operationlogrepostlist, setOperationlogrepostlist] = useState([])
  const [userFilterList, setUserFilterList] = useState([])
  const [userchecked, setUserchecked] = useState([])
  const [userSearch, setUserSearch] = useState("")
  const [datefilter, setDatefilter] = useState([]);
  const [filtername, setFiltername] = useState('');
  const [limit, setLimit] = useState(100);
  const [printparmission, setPrintparmission] = useState(0)
  const [showloader, setShowloader] = useState(false)
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  useEffect(() => {
    if (parmissiondatashow?.user_reports?.View)
      setPrintparmission(parmissiondatashow?.user_reports?.Print);
    // eslint-disable-next-line
  }, []);
  const toUsersPayload = (ids = []) => {
    return userFilterList
      .filter((user) => ids.includes(user?.id))
      .map((user) => ({ id: user.id, admin: user.admin === true }));
  };

  const operationlogrepost = async (current, firstlimit, search, usersPayload) => {
    setShowloader(true)
    try {
      const selectedUsers = usersPayload !== undefined ? usersPayload : appliedUsersRef.current;
      const postdata = {
        "search": search ? search : "",
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : "",
        "limit": firstlimit ? firstlimit : limit,
        "skip": current ? (current - 1) * limit : 0,
      };
      if (selectedUsers?.length) {
        postdata.users = selectedUsers;
      }

      let res = await _Api(postdata, `api/v1/App/User/OperationLogs`);
      const list = Array.isArray(res?.data) ? res.data : [];
      setOperationlogrepostlist(list)
      if (Array.isArray(res?.User) && res.User.length) {
        setUserFilterList(res.User)
      }
      setShowloader(false)
      if (res.code === 200) {
        setstate({
          ...state,
          totalPages: Math.ceil((res?.count || 0) / postdata.limit),
          currentPage: current ? current : 1
        });
      }
    }
    catch (err) {
      setOperationlogrepostlist([])
      setShowloader(false)
      console.log(err, 'err');
    }
  }
  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      if (!showloader) {
        operationlogrepost();
      }
    }
    // eslint-disable-next-line
  }, [datefilter]);
  const filterbyname = (search) => {
    if (!showloader) {
      operationlogrepost(1, limit, search);
      setstate({ ...state, currentPage: 1 });
    }
  };
  const getlimit = (limit) => {
    if (!showloader) {
      setLimit(limit);
      operationlogrepost(1, limit);
      setstate({ ...state, currentPage: 1 });
    }
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    if (!showloader) {
      setstate({ ...state, currentPage: current });
      operationlogrepost(current, "");
    }
  };

  const visibleUsers = userFilterList.filter((user) => {
    const query = userSearch.trim().toLowerCase();
    if (!query) return true;
    return (user?.name || "").toLowerCase().includes(query);
  });
  const visibleUserIds = visibleUsers.map((user) => user?.id).filter(Boolean);
  const allVisibleSelected = visibleUserIds.length > 0 && visibleUserIds.every((id) => userchecked.includes(id));

  const handleUserSelectAll = (event) => {
    if (event.target.checked) {
      setUserchecked((prevChecked) => [...new Set([...prevChecked, ...visibleUserIds])]);
    } else {
      setUserchecked((prevChecked) => prevChecked.filter((id) => !visibleUserIds.includes(id)));
    }
  };

  const handleUserFilterChange = (event, userId) => {
    setUserchecked((prevChecked) =>
      event.target.checked
        ? [...prevChecked, userId]
        : prevChecked.filter((item) => item !== userId)
    );
  };

  const hideUserDropdown = () => {
    dropdownRefUser.current?.classList.remove("show");
  };

  const applyUserFilter = () => {
    const users = toUsersPayload(userchecked);
    appliedUsersRef.current = users;
    operationlogrepost(1, limit, filtername, users);
    setstate({ ...state, currentPage: 1 });
    hideUserDropdown();
  };

  const clearUserFilter = () => {
    setUserchecked([]);
    setUserSearch("");
    appliedUsersRef.current = [];
    operationlogrepost(1, limit, filtername, []);
    setstate({ ...state, currentPage: 1 });
    hideUserDropdown();
  };

  const selectOptions = [
    { label: "100", value: "100" },
    { label: "200", value: "200" },
    { label: "300", value: "300" }
  ]

  return (
    <>
      <div className="main-body users-report-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

              {/* Title + filters stay under the header and tabs while the list scrolls. */}
              <div className="users-report-sticky-toolbar" ref={stickyToolbarRef}>
              <h1 className="main-body-heading mb-4">
                {t("Operation Log Report")}
              </h1>

              <div className="main-body-top-status-bar">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => { setLimit(e.value); getlimit(e.value) }}
                />

                <div className="main-body-top-status-bar-filter">
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("Search")}
                    onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                  <button onClick={() => filterbyname(filtername)} className="main-body-top-status-bar-filter-search">
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker align-items-center">
                  <DateRange setDatefilter={setDatefilter} />
                  <button className={printparmission ? "btn-style stock-take-inner-row-col-mid-header-right-btn mx-1" : "d-none"} type="button">
                    <img className="note" src={base_assets + "images/icons/printer-icon.png"} alt="" />
                  </button>
                </div>
              </div>

              </div>

              <div
                className="main-body-main-table-wrap position-relative"
              >
                <table
                  id="operationlogrepostlist"
                  className="common-table table-striped main-table w-100 users-report-sticky-thead"
                >
                  <thead>
                    <tr>
                      <th>{t("Time")}</th>
                      <th>
                        {t("User")}
                        <div className="dropdown d-inline-block com-custom-table-tag-filter dtbs-filter-dropdown">
                          <button className="after-none bg-transparent border-0 dropdown-toggle p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                            <img className="ms-2 com-custom-table-tag-filter-img" src={base_assets + "images/icons/table-filter-icon.png"} alt="" />
                          </button>
                          <div className="dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"
                            ref={dropdownRefUser}>
                            <div className="com-custom-table-tag-filter-menu-search">
                              <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
                                <img src={base_assets + "images/icons/search-icon.png"} alt="" />
                                <input className="border-0" type="text" placeholder={t("Search")}
                                  value={userSearch}
                                  onChange={(e) => setUserSearch(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="com-custom-table-tag-filter-menu-select">
                              <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
                                <div>
                                  <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id="operation-log-user-all"
                                    onChange={handleUserSelectAll}
                                    checked={allVisibleSelected} />
                                  <label className="form-check-label cursor-pointer fw-semibold" htmlFor="operation-log-user-all">{t("Select All")}</label>
                                </div>
                                <label>{userchecked?.length}/{visibleUsers?.length} {t("Selected")}</label>
                              </div>
                              <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                                {visibleUsers?.length ? visibleUsers.map((result, key) => {
                                  return (
                                    <li className="com-custom-table-tag-filter-menu-select-list-single" key={result?.id || key}>
                                      <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id={"operation-log-user-" + (result?.id || key)}
                                        onChange={(e) => handleUserFilterChange(e, result?.id)}
                                        checked={userchecked.includes(result?.id)} />
                                      <label className="form-check-label cursor-pointer" htmlFor={"operation-log-user-" + (result?.id || key)}>{result?.name}</label>
                                    </li>
                                  )
                                }) : ""}
                              </ul>
                            </div>
                            <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
                              <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor" onClick={clearUserFilter}>{t("Clear")}</button>
                              <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold" onClick={applyUserFilter}>{t("Apply")}</button>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th>{t("Category")}</th>
                      <th>{t("Action")}</th>
                      <th>{t("Operation Detail")}</th>
                      <th>{t("Device")}</th>
                    </tr>
                  </thead>
                  <tbody>
                      {operationlogrepostlist.length ? operationlogrepostlist.map((result, key) => {
                        return (
                          <tr className="" key={key}>
                            <td className="fixed-side">{result?.date ? result?.date : "-"}  <span className="badge bg-danger rounded-1">{result?.country ? result?.country : ""}</span></td>
                            <td className="fixed-side">{result?.user ? result?.user : "-"}</td>
                            <td className="fixed-side">{result?.Category ? result?.Category : "-"}</td>
                            <td className="fixed-side">{result?.action ? result?.action : "-"}</td>
                            <td className="fixed-side">{result?.Operation_Detail ? result?.Operation_Detail : "-"}</td>
                            <td className="fixed-side">{result?.device ? result?.device : "-"}</td>
                          </tr>
                        )
                      }) : !showloader &&
                      <tr>
                        <td colSpan={6} className="text-center">{t("No Data Available In Table")}</td>
                      </tr>
                      }
                  </tbody>
                </table>
                {showloader && <TableLoader />}
              </div>
            </div>
          </div>
        </div>
        {operationlogrepostlist.length > 0 ? (
          <Pagination
            total={totalPages}
            current={currentPage}
            pagination={(crPage) => handlePaginations(crPage)}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default OperationLogReport;
